<template>
    <span v-if="error || $slots.default" class="text-sm text-danger">
        <template v-if="error">{{ error }}</template>
        <slot v-else></slot>
    </span>
</template>

<script>
export default {
    props: {
        error: String
    }
}
</script>
